import { r, createSender, createUpdater } from '@/plugins/resource/resource'
import { queryPostfix } from '@/plugins/resource/api'

const  c = (...args) => args.join('')

// Models
const MODEL = 'network'

export const networkCreateResource = r('/create/', MODEL, createSender)
export const networkDetailResource = r('/detail{/id}/', MODEL)
export const networkListResource = r(queryPostfix('/list/', []), MODEL)
export const networkUpdateResource = r('/update{/id}/', MODEL, createUpdater)
